module.exports = __webpack_public_path__ + "media/audio10.3b6192a3.mp3";